// The vanilla client (not better-auth/react): the session lives in the
// React Query cache (see authQueries.ts), so the react entry's
// nanostore-backed useSession hook — a second cache — stays out of reach.
import { createAuthClient } from "better-auth/client";
import { inferAdditionalFields, organizationClient } from "better-auth/client/plugins";

import { DASHBOARD_API_URL } from "./env";

export const authClient = createAuthClient({
  baseURL: `${DASHBOARD_API_URL}/api/auth`,
  plugins: [
    // Mirrors the server's user.additionalFields so session.user.isPlatformAdmin is typed.
    inferAdditionalFields({ user: { isPlatformAdmin: { type: "boolean", input: false } } }),
    // Only for acceptInvitation on /accept-invite — team management goes
    // through tRPC so platform admins (non-members) can manage any tenant.
    organizationClient(),
  ],
  fetchOptions: {
    credentials: "include",
  },
});
